var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1886 4.62332H6.07071C4.3748 4.62332 3 5.99808 3 7.69393V17.9294C3 19.6252 4.3748 21 6.07071 21H16.3064C18.0023 21 19.3771 19.6252 19.3771 17.9294L19.3771 12.8117M8.11784 15.8822L11.8419 15.1319C12.0396 15.092 12.2211 14.9947 12.3637 14.852L20.7004 6.51105C21.1001 6.11114 21.0998 5.46291 20.6998 5.06334L18.9338 3.29938C18.5339 2.89997 17.886 2.90024 17.4864 3.29999L9.14889 11.6419C9.0066 11.7842 8.90944 11.9654 8.86957 12.1627L8.11784 15.8822Z",
    stroke: "#434343",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.891c2e64a0978c6f3dee9b15dde10e93.svg";
export { ForwardRef as ReactComponent };